import { buildInitialValues } from '../helpers'
import type { MilestoneItem, MilestonesWidgetSettings } from './milestonesWidgetSettingsSchema'
import { MilestoneDisplayMode } from './types'

const DEFAULT_FONT_COLOR = 'ffffff'
const DEFAULT_FONT = 'Fira Sans'
const DEFAULT_FONT_WEIGHT = 400
const DEFAULT_FONT_SIZE = 16
export const DEFAULT_MILESTONE_ALERT = 'defaultMilestoneAlert'

export const MILESTONE_SUGGESTED_STEP = 100

export const milestoneFormDefaultValues = {
  id: null,
  amountInCents: MILESTONE_SUGGESTED_STEP,
  gifUrl: DEFAULT_MILESTONE_ALERT,
  gifName: 'default.gif', // we show this as a default value for the gif
  soundUrl: null,
  gif: null,
  sound: null,
}

const defaultValues = {
  darkMode: true,
  mode: MilestoneDisplayMode.MilestoneAndAlert,
  headlineFont: DEFAULT_FONT,
  headlineFontWeight: 700,
  headlineFontSize: 24,
  headlineFontColor: DEFAULT_FONT_COLOR,
  dataFont: DEFAULT_FONT,
  dataFontWeight: DEFAULT_FONT_WEIGHT,
  dataFontSize: DEFAULT_FONT_SIZE,
  dataFontColor: DEFAULT_FONT_COLOR,
  milestoneItems: [],
} satisfies MilestonesWidgetSettings

const getDefaultValues = buildInitialValues(defaultValues)

export function getMilestoneDefaultValues({
  milestones,
  milestone,
  step = MILESTONE_SUGGESTED_STEP,
}: {
  milestones: MilestoneItem[]
  milestone?: MilestoneItem
  step?: number
}) {
  const highestMilestone = milestones[milestones.length - 1]
  const nextMilestone = milestone ?? {
    amountInCents: (highestMilestone?.amountInCents || 0) + step,
  }

  return buildInitialValues(milestoneFormDefaultValues)(nextMilestone)
}

export default getDefaultValues
